import {
    CapitalizedText,
    CellWrapper,
} from './styled';

interface Props {
    value?: string;
}

const PlatformColumn = ({ value }: Props) => (
    <CellWrapper>
        <CapitalizedText>
            {value}
        </CapitalizedText>
    </CellWrapper>
);

export default PlatformColumn;
